module.exports = __webpack_public_path__ + "img/thumbnail_AfricanPenguin_j_albino.d6298b91.png";